export default "__VITE_ASSET__B$9$YHBT__"